import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import _isEmpty from 'lodash/isEmpty';

// Components
import Amount from '../Amount';

// Icons
import CartIcon from '../../icons/cart.svg';

// Router
// Styles
import styles from './FloatingCart.styl';
import AsideModal from './AsideModal';
import Cart from '../Cart/Cart';

const cx = classNames.bind(styles);

export default function FloatingCart(props) {
  const { className } = props;
  const { composition, discount_price } = useSelector(state => state.cart);
  const isHomeCategoriesStick = useSelector(state => state.ui.isHomeCategoriesStick);
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className={cx('FloatingCart', className, {
          FloatingCart_visible: !_isEmpty(composition) && isHomeCategoriesStick,
        })}
        onClick={() => setOpen(true)}
      >
        <div className={cx('FloatingCart__icon')}>
          <CartIcon width={28} height={28} />
        </div>
        {discount_price > 0 && (
          <Amount className={cx('FloatingCart__amount')} value={discount_price} size="s" />
        )}
      </div>

      <AsideModal open={open} onClose={() => setOpen(false)}>
        <Cart className={cx('MainSidebar__cart')} isOpen={open} />
      </AsideModal>
    </>
  );
}

FloatingCart.defaultProps = {
  className: '',
};

FloatingCart.propTypes = {
  className: PropTypes.string,
};
